import { initializeApp } from 'firebase/app';

const preprodConfig = {
  apiKey: 'AIzaSyDKPCnkSZCWvQ3tIjajyPOAQCm9KHVZxMM',
  authDomain: 'nrk-pin-maskorama-preprod.firebaseapp.com',
  projectId: 'nrk-pin-maskorama-preprod',
  storageBucket: 'nrk-pin-maskorama-preprod.firebasestorage.app',
  messagingSenderId: '1034600330783',
  appId: '1:1034600330783:web:b202ff5d8707b4942f472a',
};
const prodConfig = {
  apiKey: 'AIzaSyChY2wvlFD50kmPMJ5xG3eIupHprOGdGgU',
  authDomain: 'nrk-pin-maskorama.firebaseapp.com',
  projectId: 'nrk-pin-maskorama',
  storageBucket: 'nrk-pin-maskorama.firebasestorage.app',
  messagingSenderId: '953671638896',
  appId: '1:953671638896:web:49b6891318dec6ee2579b5',
};

const firebaseConfig =
  import.meta.env.VITE_APP_ENV === 'prod' ? prodConfig : preprodConfig;

export const app = initializeApp(firebaseConfig);
